export const TALKS_HAS_ERRED = 'TALKS_HAS_ERRED';
export const TALKS_IS_LOADING = 'TALKS_IS_LOADING';
export const TALKS_FETCHED_OK = 'TALKS_FETCHED_OK';
